// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"475":"73f9f27b","787":"7e8380ac"}[chunkId] + ".chunk.js";
};